// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListSchedulingObligationData } from './genericApiResponseListSchedulingObligationData';
import type { GenericApiResponseListSchedulingObligationMessage } from './genericApiResponseListSchedulingObligationMessage';
import type { GenericApiResponseListSchedulingObligationPagination } from './genericApiResponseListSchedulingObligationPagination';
import type { GenericApiResponseListSchedulingObligationError } from './genericApiResponseListSchedulingObligationError';

export interface GenericApiResponseListSchedulingObligation {
  data?: GenericApiResponseListSchedulingObligationData;
  message?: GenericApiResponseListSchedulingObligationMessage;
  pagination?: GenericApiResponseListSchedulingObligationPagination;
  error?: GenericApiResponseListSchedulingObligationError;
  statusCode?: number;
}
